export default {
  swap: (arr, indexA, indexB) => {
    const temp = arr;

    [temp[indexA], temp[indexB]] = [temp[indexB], temp[indexA]];

    return temp;
  }
};
